module.exports = __webpack_public_path__ + "static/media/python blockly-icon.14e4447c.png";